<template>
  <div class="dashboard">
    <el-row :gutter="20">
      <!-- 统计卡片 -->
      <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-icon">
              <el-icon size="40" color="#409EFF"><Document /></el-icon>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ stats.totalPdfs }}</div>
              <div class="stat-label">总PDF数量</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-icon">
              <el-icon size="40" color="#67C23A"><DocumentAdd /></el-icon>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ stats.todayPdfs }}</div>
              <div class="stat-label">今日生成</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" v-if="isAdmin">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-icon">
              <el-icon size="40" color="#E6A23C"><User /></el-icon>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ stats.totalUsers }}</div>
              <div class="stat-label">用户总数</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-icon">
              <el-icon size="40" color="#F56C6C"><Setting /></el-icon>
            </div>
            <div class="stat-info">
              <div class="stat-number">8</div>
              <div class="stat-label">算法模型</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px">
      <!-- 快速操作 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>快速操作</span>
            </div>
          </template>
          <div class="quick-actions">
            <el-button
              type="primary"
              @click="$router.push('/generate')"
            >
              <el-icon><DocumentAdd /></el-icon>
              生成PDF
            </el-button>
            <el-button
              type="success"
              @click="$router.push('/pdfs')"
            >
              <el-icon><Document /></el-icon>
              我的PDF
            </el-button>
            <el-button
              v-if="isAdmin"
              type="warning"
              @click="$router.push('/users')"
            >
              <el-icon><User /></el-icon>
              用户管理
            </el-button>
          </div>
        </el-card>
      </el-col>

      <!-- 最近生成的PDF -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>最近生成的PDF</span>
              <el-button type="text" @click="$router.push('/pdfs')"
                >查看全部</el-button
              >
            </div>
          </template>
          <div v-if="recentPdfs.length === 0" class="empty-state">
            <el-empty description="暂无PDF文件" />
          </div>
          <div v-else>
            <div
              v-for="pdf in recentPdfs"
              :key="pdf.id"
              class="recent-pdf-item"
            >
              <div class="pdf-info">
                <div class="pdf-name">{{ pdf.filename }}</div>
                <div class="pdf-meta">
                  {{ pdf.algorithm_type }} · {{ formatDate(pdf.created_at) }}
                </div>
              </div>
              <el-button type="text" @click="downloadPdf(pdf.filename)">
                <el-icon><Download /></el-icon>
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from "vue";
import { ElMessage } from "element-plus";
import axios from "axios";

export default {
  name: "Dashboard",
  setup() {
    const stats = reactive({
      totalPdfs: 0,
      todayPdfs: 0,
      totalUsers: 0,
    });

    const recentPdfs = ref([]);

    const isAdmin = computed(() => {
      return localStorage.getItem("isAdmin") === "true";
    });

    const loadStats = async () => {
      try {
        // 获取PDF统计
        const pdfResponse = await axios.get("/api/pdfs");
        const pdfs = pdfResponse.data.pdfs;
        stats.totalPdfs = pdfs.length;

        // 计算今日生成的PDF数量
        const today = new Date().toISOString().split("T")[0];
        stats.todayPdfs = pdfs.filter((pdf) =>
          pdf.created_at.startsWith(today)
        ).length;

        // 获取最近的PDF
        recentPdfs.value = pdfs.slice(0, 5);

        // 如果是管理员，获取用户统计
        if (isAdmin.value) {
          const userResponse = await axios.get("/api/users");
          stats.totalUsers = userResponse.data.users.length;
        }
      } catch (error) {
        console.error("加载统计数据失败:", error);
      }
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleString("zh-CN");
    };

    const downloadPdf = async (filename) => {
      try {
        const response = await axios.get(`/api/pdfs/${filename}/download`, {
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        ElMessage.success("下载成功");
      } catch (error) {
        ElMessage.error("下载失败");
      }
    };

    onMounted(() => {
      loadStats();
    });

    return {
      stats,
      recentPdfs,
      isAdmin,
      formatDate,
      downloadPdf,
    };
  },
};
</script>

<style scoped>
.dashboard {
  padding: 0;
}

.stat-card {
  margin-bottom: 20px;
}

.stat-content {
  display: flex;
  align-items: center;
  padding: 10px;
}

.stat-icon {
  margin-right: 20px;
}

.stat-info {
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.stat-label {
  color: #666;
  font-size: 14px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.quick-actions {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.quick-actions .el-button {
  flex: 1;
  min-width: 120px;
}

@media (max-width: 768px) {
  .stat-content {
    flex-direction: column;
    text-align: center;
  }
  
  .stat-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .stat-number {
    font-size: 24px;
  }
  
  .quick-actions {
    flex-direction: column;
  }
  
  .quick-actions .el-button {
    width: 100%;
    min-width: auto;
  }
  
  .recent-pdf-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

.recent-pdf-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.recent-pdf-item:last-child {
  border-bottom: none;
}

.pdf-info {
  flex: 1;
}

.pdf-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 5px;
}

.pdf-meta {
  font-size: 12px;
  color: #999;
}

.empty-state {
  text-align: center;
  padding: 20px;
}
</style>
